module.exports = require("@agm/core/services/maps-api-loader/lazy-maps-api-loader");